module.exports = __webpack_public_path__ + "img/message-middle.23db50a0.svg";